<div class="pb-2 font-weight-bold text-blue bg-white px-4 pt-4">
  <h2 class="">Project Application Notification Results</h2>
</div>

<div class="white-bg pt-3">
  <table id="project-application-table" class="table table-striped table-bordered table-hover" cellspacing="0" width="100%"></table>
</div>
